import React, { useCallback, useEffect, useState } from 'react';
import { useGeolocation } from 'react-use';
import _ from 'lodash';
import type { GeoLocationSensorState } from 'react-use/lib/useGeolocation';
import { isServer } from '@sitecore-jss/sitecore-jss';
import {} from 'google-maps';

export const usePositionGeocoding = () => {
  if(!isServer()){
    
    const locationState = useGeolocation();
  
    const [geocoder, setGeocoder]: any = useState<google.maps.Geocoder>();
    const [countryCode, setCountryCode] = useState<string | null>(null);

    // ----- load google geocoding script -----
    useEffect(() => {
     
        registerScript();
    
    }, []);

    useEffect(() => {
      console.log(locationState);
      if (locationState.loading || !geocoder) return;

      reverseGeocode(locationState, geocoder.geocode);
    }, [locationState, geocoder]);

    const reverseGeocode = useCallback(
      _.debounce(
        async (
          { latitude: lat, longitude: lng }: GeoLocationSensorState,
          geocodeFn: (
            request: google.maps.GeocoderRequest,
            callback?: (
              a: google.maps.GeocoderResult[],
              b: google.maps.GeocoderStatus
            ) => void
          ) => Promise<google.maps.GeocoderResponse>
        ) => {
          const result = await geocodeFn({ location: { lat, lng } });
          const newCountryCode = result.results[0].address_components.find(
            (comp) => comp.types.includes('country')
          )?.short_name;

          setCountryCode(newCountryCode);
        },
        500,
        { trailing: true }
      ),
      []
    );

    const registerScript = useCallback(() => {
      if(typeof document != 'undefined') {
        if (!Array.from(document.scripts).find((e) => e.src === GOOGLE_API)) {
          const script = document.createElement('script');
          script.src = GOOGLE_API;
          script.addEventListener('load', () => {
            setGeocoder(new google.maps.Geocoder());
          });
          document.body.appendChild(script);
        }
      }
    }, []);

    return countryCode;
  } else {
    return null
  }

};

const API_KEY = 'AIzaSyAwujLgegYvocPgUrAhlzagwUvBkBlm75w';
const GOOGLE_API = `https://maps.googleapis.com/maps/api/js?libraries=places&key=${API_KEY}`;
